<template>
  <div>
    <span class="caption grey--text text--darken-1">
      {{ label }}
    </span>

    <v-autocomplete
      id="icd11"
      v-model="selection"
      :loading="loading"
      :items="items"
      :menu-props="{ contentClass: 'icd-autocomplete' }"
      :search-input.sync="search"
      :hint="selection ? selection.code : ''"
      persistent-hint
      clearable
      no-filter
      hide-no-data
      :label="label"
      solo
      return-object
      class="thin-border"
    >
      <template v-slot:item="data">
        <template>
          <div>
            <small
              ><b>{{ data.item.code }}</b></small
            >
            - <span class="my-1" v-html="data.item.text"></span><br />
            <ul>
              <template v-for="(item, key) in data.item.synonym">
                <li :key="key" v-if="key < 3"><small v-html="item"></small></li>
                <li v-if="key === 3" :key="key + 1"><small>...more</small></li>
              </template>
            </ul>
          </div>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import icd11helper from '@/helpers/icd11-helper'
export default {
  props: {
    value: { default: null },
    label: { type: String, default: 'Pesquisa de diagnóstico' }
  },
  data() {
    return {
      loading: false,
      items: [],
      search: null,
      select: null,
      icd11Cache: {}
    }
  },
  computed: {
    selection: {
      get() {
        return this.value
      },
      set(value) {
        value && value.text
          ? (value.text = value.text.replaceAll("<em class='found'>", ''))
          : ''
        value && value.text
          ? (value.text = value.text.replaceAll('</em>', ''))
          : ''
        this.$emit('input', value)
      }
    }
  },
  methods: {
    async fetchItems(query = '') {
      if (!query.trim()) {
        return
      }
      try {
        if (!this.icd11Cache[query]) {
          this.icd11Cache[query] = await icd11helper.searchICD11(query)
        }
        this.items = this.icd11Cache[query]
      } catch (err) {
        console.error(err)
        this.$store.dispatch('showErrorSnackbar', 'Algo deu errado')
      }

      this.loading = false
    }
  },
  created() {
    if (this.value) {
      this.items = [this.value]
    }
  },
  mounted() {
    let input = document.getElementById('icd11')
    let timeout = null
    input.addEventListener('keyup', () => {
      this.loading = true
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        this.fetchItems(this.search)
      }, 500)
    })
  }
}
</script>

<style>
div.icd-autocomplete a {
  height: 100%;
}
</style>
